import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { ErrorState } from '@leanin/ui';
import { RetryButton } from '@/components/states/index';
import {
  fetchMyContestation,
  moderationKeys,
} from '@/lib/queries/moderation';
import { ContestStatusView } from './-components/ContestStatusView';

export const Route = createFileRoute(
  '/_authed/moderation/contest/$contestationId/',
)({
  component: ContestStatusPage,
});

function ContestStatusPage() {
  const { contestationId } = Route.useParams();
  const query = useQuery({
    queryKey: moderationKeys.myContestation(contestationId),
    queryFn: () => fetchMyContestation(contestationId),
    retry: false,
  });

  if (query.isLoading) return null;
  if (query.isError) {
    const status = (query.error as { status?: number })?.status;
    const isNotFound = status === 404;
    return (
      <ErrorState
        title="We couldn't load that contestation."
        body={
          isNotFound
            ? "We can't find this contestation, or it doesn't belong to your account."
            : "Something on our end didn't respond. Give it a moment and try again."
        }
        reference={isNotFound ? 'http_404' : 'http_500'}
        {...(isNotFound ? {} : { primary: <RetryButton /> })}
      />
    );
  }
  return <ContestStatusView contestationId={contestationId} />;
}
